module.exports = __webpack_public_path__ + "img/userid-tip.8871596.jpg";